export default __webpack_public_path__ + "static/media/icon-check-miss.c1c15781.svg";